export default __webpack_public_path__ + "assets/webgl/picking-24.cf2c47ab.glb";